import { useState } from "react";

interface MoreInfoIconProps {
  colorIcon: string;
  msg: string;
}

const MoreInfoIcon: React.FC<MoreInfoIconProps> = ({ colorIcon, msg }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <div className="group flex items-center relative">
      <button
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
        className="flex gap-2 justify-center hover:cursor-pointer bg-transparent border-none p-0"
        type="button"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke={colorIcon}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            ></circle>
            <rect
              height="0.01"
              stroke={colorIcon}
              strokeLinejoin="round"
              strokeWidth="3"
              width="0.01"
              x="12"
              y="8"
            ></rect>
            <path
              d="M12 12V16"
              stroke={colorIcon}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            ></path>
          </g>
        </svg>
      </button>
      {isTooltipVisible && (
        <div className="absolute z-50 group-hover:visible text-xs bg-gray-50 text-black p-1.5 rounded-md shadow-lg ml-8">
          <p className="text-[8px] text-start ">{msg}</p>
        </div>
      )}
    </div>
  );
};

export default MoreInfoIcon;
